import { createApi } from "../../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { checkArmedStatus } from "./checkArmedStatus";
import { universalAPIErrorHandler } from "../../../../utils/universalAPIErrorHandler";
import { getNumbersAfterAboutSite } from "../SiteAbout";
import { logger } from "../../../../../utils/logger";
import { requestCameraStatusRefresh } from "./cameraStatusPolling";

export const handleArmSite = async (
  setBackdropLoadingScreenOn: any,
  setSiteInfo: any,
  setAlertState: any,
  setSyncNeeded: any,
  setArmedStatus: any,
  navigate: any,
  setArmButtonDisabled: any,
  // "arm" for the Arm button; "reboot" for the restart-to-apply-settings
  // flows. Both dispatch identically backend-side, but reboot logs a
  // "Manual Reboot" action instead of a "Manual Arm" the operator never
  // performed (ENG-1380 / SUP-433).
  endpointAction: "arm" | "reboot" = "arm"
) => {
  const AxiosUI = createApi(``);
  setBackdropLoadingScreenOn(true);
  const retryFunction = () => {
    handleArmSite(
      setBackdropLoadingScreenOn,
      setSiteInfo,
      setAlertState,
      setSyncNeeded,
      setArmedStatus,
      navigate,
      setArmButtonDisabled,
      endpointAction
    );
  };
  let siteArmFail = false;

  await AxiosUI.post(
    `customer/${getNumbersAfterAboutSite(location.href)}/action/${endpointAction}/`
  ).then(
    () => {
      siteArmFail = false;
      // The connector restarts: refresh every camera's status (ENG-2853).
      requestCameraStatusRefresh();
    },
    (reason: AxiosError) => {
      siteArmFail = true;
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setBackdropLoadingScreenOn(false);
        setSiteInfo((previousState: any) => {
          return { ...previousState, armed: false };
        });
      });
    }
  );
  !siteArmFail &&
    (await AxiosUI.get(
      `customer/${getNumbersAfterAboutSite(location.href)}/about/`
    ).then(
      (response: AxiosResponse) => {
        checkArmedStatus(
          response.data,
          setArmButtonDisabled,
          navigate,
          setSiteInfo,
          setArmedStatus
        );
        setSiteInfo(response.data);
        if (response.data.settings_deployed !== true) {
          setSyncNeeded(true);
        }
        if (
          response.data.armed_status === "ARMING" ||
          response.data.armed_status === "ARMED_OUTSIDE_SCHEDULE"
        ) {
          setAlertState((previousState: any) => {
            return {
              ...previousState,
              changeSuccess: false,
              activateSuccess: false,
              deactivateSuccess: false,
              disarmSuccess: false,
              armSuccess: true,
              syncSuccess: false,
              cameraDeleteSuccess: false,
              armFail: false,
            };
          });
        }
        setArmedStatus(true);
        setBackdropLoadingScreenOn(false);
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          {
            setAlertState((previousState: any) => {
              return {
                ...previousState,
                changeSuccess: false,
                activateSuccess: false,
                deactivateSuccess: false,
                disarmSuccess: false,
                armSuccess: false,
                syncSuccess: false,
                cameraDeleteSuccess: false,
                armFail: true,
              };
            });
          }
          setBackdropLoadingScreenOn(false);
          logger.log(JSON.stringify(reason.message));
        });
      }
    ));
};
